import { useState } from 'react';
import { ParagraphWrapper, SubmitDescription } from './BillingInfo.styles';
import { Drawer } from '@/common/ui/drawer';
import { getHelpPage } from '@/common/service/api/HelpPages/HelpPages';
import Paragraph from '@/shared/Paragraph/ui/Paragraph';
import { Preloader } from '@/common/ui/loaders/Preloader';

type TMode = 'Terms of Use' | 'Privacy Policy';
const SLUGS = {
    'Terms of Use': 'terms',
    'Privacy Policy': 'policy',
};

export const AgreementInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [mode, setMode] = useState<TMode>('Terms of Use');
    const [content, setContent] = useState({
        'Terms of Use': '',
        'Privacy Policy': '',
    });

    const handleClick =
        (selectedMode: TMode) => async (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
            e.preventDefault();

            setIsOpen(true);
            setMode(selectedMode);

            if (!content[selectedMode]) {
                const data = await getHelpPage(SLUGS[selectedMode]);

                if (data && data.content) {
                    setContent((prev) => ({ ...prev, [selectedMode]: data.content }));
                }
            }
        };

    return (
        <>
            <SubmitDescription>
                By clicking &quot;Pay & Reserve&quot;, you agree to TripShock&apos;s{' '}
                <a href="" target="_blank" onClick={handleClick('Terms of Use')}>
                    Terms of Use
                </a>{' '}
                and{' '}
                <a href="" target="_blank" onClick={handleClick('Privacy Policy')}>
                    Privacy Policy
                </a>{' '}
                and acknowledge that you are entering into a direct agreement with the supplier of
                the experience as listed. You also consent to receive updates from TripShock
                including travel inspiration, helpful tips, and exclusive offers, which you can
                unsubscribe from at any time.
            </SubmitDescription>
            {
                <Drawer open={isOpen} setOpen={() => setIsOpen(false)} title={mode}>
                    <ParagraphWrapper>
                        {content[mode] ? (
                            <Paragraph
                                className="table-layout"
                                id="ts_paragraph"
                                innerHtml={content[mode]}
                            />
                        ) : (
                            <Preloader />
                        )}
                    </ParagraphWrapper>
                </Drawer>
            }
        </>
    );
};
